module.exports = __webpack_public_path__ + "static/media/closeMainImg.5f1313f4.png";